<template>
    <div class="flex-grow-1 d-flex flex-column">
      <filtered-data
        ref="data"
        v-model="data"
        endpoint="billing/settings/regions"
        :loading.sync="loading"
        :hasMore.sync="hasMore"
    ></filtered-data>
  
      <div class="container-fluid">
        <div class="d-flex align-items-center">
          <h2 class="page-heading mr-auto">Настройки организаций</h2>
        </div>
      </div>
  
      <template v-if="data && data.data">
        <data-table-full-height
            :data="data.data"
            :hasMore="hasMore"
            :loading="loading"
            @load-more="$refs.data.loadMore"
        >
          <el-table-column type="expand">
            <p>ssss</p>
          </el-table-column>
          <el-table-column
            prop="name"
            label="Название"
            align="left"
          />
          <el-table-column
            prop="code"
            label="Код"
            width="350"
            align="left"
          />
        </data-table-full-height>
      </template>
    </div>
  </template>
  
  <script>
    import moment from 'moment'
    import api from '@/api'
  
    export default {
      metaInfo () {
        return {title: `Настройки организаций`}
      },
      data () {
        return {
          filtersValue: null,
          data: {
            data: [
                {
                    'code': 'test',
                    'name': 'Тестовая настройка',
                    'value': 'maximal',
                    'edit': true,
                    'id': 0
                }
            ]
          },
          loading: false,
          hasMore: true,
          sort: {prop: 'updated_at', order: 'asc'},
          updateList: 0,
          externalFilters: null,
          regionFilters: [],
        }
      },
      asyncComputed: {
        modem() {
        //   return api.get(`modems/${this.uid}`).then(({data}) => data)
            try {
            console.log(this.data)
                
            } catch (error1) {
            console.log(error1)
                
            }
            return false
        },
      },
      filters: {
      },
      methods: {
        saveSetting () {
          if (window.confirm('Вы уверены что хотите сохранить настройку?')) {
            return api.post(`billing/settings/regions/updateSetting`)
          }
        },
        refreshFilters (event) {
          this.filtersValue = Object.assign({}, this.filtersValue, event)
        },
      },
    }
  </script>
  
  <style lang="scss">
    @import "boot";
    .modem-command-data-result-preview {
      @include text-overflow-lines(2);
      position: relative;
      &:after {
        content: '';
        position: absolute;
        bottom: -1px;
        left: 0;
        width: 100%;
        height: .6em;
        pointer-events: none;
        @include gradient-y(rgba(#fff, 0), rgba(#fff, .3));
      }
    }
    .modem-command-details-expand .modem-command-data-result {
      max-height: 29.5 * $line-height-base * 1em;
    }
  </style>
  


// WEBPACK FOOTER //
// resources/assets/js/pages/billing/settings/regions.vue